module.exports = __webpack_public_path__ + "img/user-bounty-hunter.35870af7.svg";